import { Span } from "../../../../../../components/span/Span"
import { Table, TableContainer, TableData, TableRow, Tbody } from "./ContractSelectionTable.styled"
import { theme } from "../../../../../../styles/stitches.config"

interface TableRowData {
  name: string
  value: string
  unit?: string
  tariff?: boolean
}

export function DynamicTable({ rowData }: { rowData: TableRowData[] }) {
  return (
    <TableContainer>
      <Table>
        <Tbody>
          {rowData.map((row, index) => (
            <TableRow key={index}>
              <TableData>{row.name}</TableData>
              <TableData price tariff={row.tariff}>
                {row.value}
                <Span css={{ fontSize: theme.sizes.s3 }}>{row.unit}</Span>
              </TableData>
            </TableRow>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
